/**
 * CZNA-1168 — reads the languages of the register's VARIANT headings from
 * GET /czna-authorities/records/index/languages, for the "Jazyk" filter of the
 * register (Záhlaví).
 *
 * <p>The offering comes from the corpus, not from a list in code (the DB-061 lesson):
 * on 29. 9. 2026 the local corpus carried 77 languages in `4XX $2`, while the language
 * vocabulary has 486 terms — offering those would mostly be options that match nothing.
 *
 * <p>`recordType` is the register type currently in force, so the filter only offers
 * languages that type has. `languages` is `[]` while loading and on failure; the filter
 * then degrades to "Všechny jazyky" (plus an already-applied value) instead of breaking.
 */
import { useRef } from 'react';
import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { fetchIndexLanguages } from '../api/recordService';
var INDEX_LANGUAGES_KEY = 'czna-authorities-index-languages';
export var useIndexLanguages = function (recordType) {
    var _a;
    // Unstable-`ky` trap: useOkapiKy() returns a fresh instance each render; key only on
    // serializable params and read ky from a ref (same as useRecordIndex).
    var ky = useOkapiKy();
    var kyRef = useRef(ky);
    kyRef.current = ky;
    var _b = useQuery([INDEX_LANGUAGES_KEY, recordType !== null && recordType !== void 0 ? recordType : null], function () { return fetchIndexLanguages(kyRef.current, { recordType: recordType }); }), data = _b.data, isLoading = _b.isLoading, isError = _b.isError;
    return {
        languages: (_a = data === null || data === void 0 ? void 0 : data.languages) !== null && _a !== void 0 ? _a : [],
        isLoading: isLoading,
        isError: isError,
    };
};
export default useIndexLanguages;
